import {
  CcfBox,
  CcfNoneFoundIcon,
  CcfTypography,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { MenuItem, Select } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfWemRecentInteractionProps {}

/**
 * CcfWemRecentInteraction - used to display wem my schedule
 * @param props - CcfWemRecentInteraction
 * @example `<CcfWemRecentInteraction />`
 */
export function CcfWemRecentInteraction(props: CcfWemRecentInteractionProps) {
  const dayHeaderFormat: any = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const today = new Date().toLocaleDateString('en-US', dayHeaderFormat);
  const yesterday = (function (d) {
    d.setDate(d.getDate() - 1);
    return d;
  })(new Date());
  const yesterdayDate = yesterday.toLocaleDateString('en-US', dayHeaderFormat);
  const yesterdayTime = yesterday.toLocaleTimeString();
  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Recent Interactions
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.recentInteractionsBox}>
        <CcfBox>
          <Select
            id="selected option"
            size="small"
            className={styles.interactionsDropdown}
            variant="outlined"
            value="Last 24 hours"
            IconComponent={() => (
              <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
            )}
          >
            <MenuItem value="Last 24 hours">Last 24 hours</MenuItem>
            <MenuItem value="Last 7 days">Last 7 days</MenuItem>
            <MenuItem value="Last 30 days">Last 30 days</MenuItem>
            <MenuItem value="Last 90 days">Last 90 days</MenuItem>
          </Select>
        </CcfBox>
        <CcfBox mt={2}>
          <CcfTypography className={styles.interactionsCountTxt}>
            Found <b>0</b> segments | {yesterdayDate} {yesterdayTime} - {today}{' '}
            11:59:59 PM
          </CcfTypography>
        </CcfBox>
        <CcfBox className={styles.noResultFoundBlock}>
          <CcfNoneFoundIcon style={{ fontSize: 240 }} />
          <CcfTypography className={styles.noResultTxt}>
            We didn't find any results
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}
